import { render, staticRenderFns } from "./TrackingCheck.vue?vue&type=template&id=0670cc63"
import script from "./TrackingCheck.vue?vue&type=script&lang=js"
export * from "./TrackingCheck.vue?vue&type=script&lang=js"
import style0 from "./TrackingCheck.vue?vue&type=style&index=0&id=0670cc63&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports